import {InputAdornment, TextField} from "@mui/material";

const AuthTextfield = ({value, onChange, type, name, placeholder, icon, ...otherProps}) => {

    return (
        <TextField
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                },
            }}
            value={value}
            onChange={onChange}
            size="small"
            type={type}
            name={name}
            placeholder={placeholder}
            fullWidth
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        {icon}
                    </InputAdornment>
                ),
            }}
            {...otherProps}
        />
    );
};

export default AuthTextfield;